import { useSelector } from 'react-redux'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { lowerCaseFirstLetter } from '../../../../../helpers/common'
import { selectYear } from '../store/slice'

export const FinancialStatementsValueCell = ({ val, style }) => {
  const { formatCurrency } = useFormatCurrency(SCREEN.PEER_ANALYSIS)

  const { value, exchangeRateType, hasData } = val || {}
  const selectedYear = useSelector(selectYear)

  return (
    hasData && (
      <div style={{ textAlign: 'right', ...style }}>
        <div
          style={{
            width: '100%',
            margin: '4px 0',
            padding: '1px 0',
          }}
        >
          {formatCurrency({
            value,
            year: selectedYear?.value,
            exchangeRateType: lowerCaseFirstLetter(exchangeRateType),
            isFinancialStatement: true,
          })}
        </div>
      </div>
    )
  )
}
